/*
 * COJ Special Order — PDP variant-aware shipping-delay message + cart-line properties.
 * Mirrors the badge-system data/JS pattern.
 *
 * Reads a variantId -> {enabled, message, type} map emitted by
 * snippets/condor-special-order-message.liquid.
 * On the selected variant changing: shows/hides the PDP message and toggles three hidden
 * cart-line property inputs on the product form:
 *   properties[_condor_special_order]   = 'true'
 *   properties[_condor_message]         = <message text>
 *   properties[_condor_fulfillment_type] = 'special_order' | 'coming_soon'
 * Disabled inputs are not submitted, so non-Special-Order variants write nothing.
 *
 * 2026-08-06: added _condor_fulfillment_type. The checkout extension needs this to
 * stop showing the mandatory Special Order acknowledgment checkbox (no returns,
 * 2-3 month wait) to Coming Soon buyers -- those terms don't apply to them.
 * Defaults to 'special_order' if the map entry has no type, so any cart line
 * added before this rollout still resolves to the original (safer) behavior.
 *
 * No-form fallback: on a template with no add-to-cart form (e.g. a coming-soon
 * layout), the selected variant can't be read, so the message is shown for the
 * first Special Order variant in the map. On normal PDPs a form exists, so this
 * fallback never triggers and the message stays variant-accurate.
 *
 * findAddToCartForm() requires the candidate to contain a real submit control
 * before picking it (fixes a prior bug where properties were written to a
 * Shop Pay installment form with no submit button and never reached the cart).
 */
(function () {
  'use strict';

  var DATA_SELECTOR = 'script.condor-so-data';
  var instances = [];

  function parseData(el) {
    try { return JSON.parse((el.textContent || '{}').trim()); } catch (e) { return {}; }
  }

  function findAddToCartForm() {
    var candidates = document.querySelectorAll('product-form form, form[action*="/cart/add"]');
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].querySelector('button[type="submit"], [name="add"]')) return candidates[i];
    }
    return candidates[0] || null;
  }

  function getVariantId(form) {
    if (form) {
      var input = form.querySelector('[name="id"]');
      if (input && input.value) return String(input.value);
    }
    var pageInput = document.querySelector('product-form form [name="id"], form[action*="/cart/add"] [name="id"]');
    if (pageInput && pageInput.value) return String(pageInput.value);
    var v = new URLSearchParams(window.location.search).get('variant');
    return v ? String(v) : null;
  }

  function ensureInputs(form) {
    if (!form) return null;
    var flag = form.querySelector('input[data-condor-flag]');
    var msg = form.querySelector('input[data-condor-msg]');
    var type = form.querySelector('input[data-condor-type]');
    if (!flag) {
      flag = document.createElement('input');
      flag.type = 'hidden';
      flag.name = 'properties[_condor_special_order]';
      flag.setAttribute('data-condor-flag', '');
      flag.disabled = true;
      form.appendChild(flag);
    }
    if (!msg) {
      msg = document.createElement('input');
      msg.type = 'hidden';
      msg.name = 'properties[_condor_message]';
      msg.setAttribute('data-condor-msg', '');
      msg.disabled = true;
      form.appendChild(msg);
    }
    if (!type) {
      type = document.createElement('input');
      type.type = 'hidden';
      type.name = 'properties[_condor_fulfillment_type]';
      type.setAttribute('data-condor-type', '');
      type.disabled = true;
      form.appendChild(type);
    }
    return { flag: flag, msg: msg, type: type };
  }

  function update(inst) {
    var vid = getVariantId(inst.form);
    if (!vid && !inst.form) {
      var keys = Object.keys(inst.map);
      if (keys.length) vid = keys[0];
    }
    var data = vid ? inst.map[vid] : null;
    var active = !!(data && data.enabled);
    if (active) {
      if (inst.textEl) inst.textEl.textContent = data.message || '';
      inst.msgEl.classList.add('is-visible');
      if (inst.inputs) {
        inst.inputs.flag.value = 'true';
        inst.inputs.msg.value = data.message || '';
        inst.inputs.type.value = data.type || 'special_order';
        inst.inputs.flag.disabled = false;
        inst.inputs.msg.disabled = false;
        inst.inputs.type.disabled = false;
      }
    } else {
      inst.msgEl.classList.remove('is-visible');
      if (inst.inputs) {
        inst.inputs.flag.disabled = true;
        inst.inputs.msg.disabled = true;
        inst.inputs.type.disabled = true;
        inst.inputs.flag.value = '';
        inst.inputs.msg.value = '';
        inst.inputs.type.value = '';
      }
    }
    inst.lastVid = vid;
  }

  function init() {
    var dataEls = document.querySelectorAll(DATA_SELECTOR);
    Array.prototype.forEach.call(dataEls, function (dataEl) {
      var root = dataEl.closest('[data-condor-so]') || dataEl.parentNode;
      if (!root || root.__condorBound) return;
      root.__condorBound = true;
      var form = root.closest('form') || findAddToCartForm();
      var inst = {
        root: root,
        map: parseData(dataEl),
        msgEl: root.querySelector('.condor-so__msg'),
        textEl: root.querySelector('.condor-so__msg-text'),
        form: form,
        inputs: ensureInputs(form),
        lastVid: null
      };
      if (!inst.msgEl) return;
      instances.push(inst);
      update(inst);
      if (form) form.addEventListener('change', function () { update(inst); });
    });
    if (instances.length && !window.__condorSoPoll) {
      window.__condorSoPoll = setInterval(function () {
        instances.forEach(function (inst) {
          if (getVariantId(inst.form) !== inst.lastVid) update(inst);
        });
      }, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
